<template>
	<el-drawer :visible.sync="show" size="600px" :withHeader="true" :show-close="false" :direction="direction" :wrapperClosable="wrapperClosable" :before-close="handleClose" class="msg" :open="open">
		<div slot="title">
			<div class="flex justify-content-space-between align-items-center">
				<div class="font-20 text-bold text-black">通知中心</div>
				<el-button type="text" @click="readAll">全部已读</el-button>
			</div>
			<el-divider></el-divider>
		</div>
		<div class="container">
			<el-scrollbar v-loading="loading" :native="false" view-class="el-scrollbar-view">
				<el-collapse v-if="list.length > 0" v-model="activeCollapse" accordion @change="readMessage">
					<el-collapse-item v-for="(item, index) in list" :key="item.msgid" :name="index">
						<template slot="title">
							<div class="header">
								<span class="status-dot" :class="[!item.is_read&&'red' ]" />
								<span v-if="item.title">{{ item.title }}</span>
								<span v-else>{{ item.message || item.text || item.content }}</span>
								<span class="time">{{ item.createtime | parseTime }}</span>
							</div>

						</template>
						<div class="flex justify-content-start">
							<div class="content" v-html="item.message || item.text || item.content"></div>
							<!-- <el-button type="text">查看详情</el-button> -->
						</div>
					</el-collapse-item>
				</el-collapse>
				<div v-else class="flex-center column mt-hg">
					<img class="image huger mt-mg" src="@/assets/empty.png" />
					<div class="font-md mb-hg">暂无数据</div>
				</div>
			</el-scrollbar>

			<div class="pagination">
				<f-pagination :sizesShow="false" :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
			</div>
		</div>
	</el-drawer>
</template>

<script>
import store from "../../../store/store";
import {
	messageListApi,
	readMessageApi,
	allReadMessageApi
} from "@/api/common/messageApi";

export default {
	name: "Msg",
	data () {
		return {
			show: false,
			wrapperClosable: true,
			direction: "rtl",
			list: [],
			total: 0,
			query: {
				pindex: 1,
				psize: 15
			},

			activeCollapse: "",
			loading: false
		};
	},
	created () {
	},

	methods: {
		open () {
			this.show = true;
			this.fetchData(1);
		},

		fetchData (page) {
			this.loading = true;
			if (page) this.query.pindex = page;
			messageListApi(this.query).then(res => {
				this.loading = false;
				if (!res.errno) {
					this.list = res.data.list;
					this.total = res.data.total;
				}
			});
		},

		handleClose (done) {
			done();
		},

		readAll () {
			// store.dispatch('getUnreadMessageNum')
			allReadMessageApi().then(res => {
				if (!res.errno) {
					// this.$message.success(res.message)
					this.fetchData();
					store.dispatch("getUnreadMessageNum");
				}
			});
		},

		readMessage (index) {
			if (index.length !== 0) {
				const item = this.list[index];
				if (item.is_read === 0) {
					readMessageApi({ msgid: item.msgid }).then(res => {
						if (!res.errno) {
							this.list[index].is_read = 1;
							store.dispatch("getUnreadMessageNum");
						}
					});
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
$--color-active-bg: #f5f7fa;
$--color-text-muted: #999999;
$--color-danger: #f56c6c;
/deep/ .el-collapse {
	border-top: 0;
}
/deep/ .el-drawer__header {
	margin-bottom: 0;
}
/deep/ .el-drawer__body {
	margin-bottom: 50px;
}
.msg {
	user-select: none;
	.container {
		padding: 0 30px;
		.el-collapse-item {
			.header {
				color: $--color-text-muted;
				font-size: 14px;
				position: relative;
				width: 100%;
				.status-dot {
					width: 6px;
					height: 6px;
					background-color: #999;
					display: inline-block;
					border-radius: 50%;
					margin-right: 7px;
					margin-left: 7px;
					&.red {
						background-color: $--color-danger;
					}
				}
				.title {
					color: inherit;
					margin-left: 10px;
				}
				.time {
					position: absolute;
					right: 20px;
					color: inherit;
				}
			}
			.content {
				padding: 0px 30px;
				margin-bottom: -10px;
				font-size: 14px;
				max-width: 100%;
			}
			&.is-active,
			&:hover {
				.el-collapse-item__header {
					background-color: $--color-active-bg;
				}
				.el-collapse-item__wrap {
					background-color: $--color-active-bg;
				}
			}
			&.is-active {
				.header {
					color: #333;
				}
			}
		}
		.pagination {
			position: absolute;
			bottom: 10px;
			right: 20px;
		}
	}
}
</style>
